import React, { ReactElement } from "react";
import FooterComponent from "../../../component/footer";

export default function Footer(): ReactElement {
  return <FooterComponent />;
}
